import { render, staticRenderFns } from "./SalvarVacinaModal.vue?vue&type=template&id=0f68b4dc"
import script from "./SalvarVacinaModal.vue?vue&type=script&lang=js"
export * from "./SalvarVacinaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports